(function($) {
	
	//gravity ajax form submit Gtag event loader
	
	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		gtag('event', 'conversion', {'send_to': 'AW-942734554/5QhXCOTym70CENr5w8ED'});
	});
	
	
	

	$(document).ready(function(){

		// Add/remove class to desktop search form on fucus/blur
		var searchField = document.querySelector('.desktop-header .search-field');
		searchField.addEventListener('focus', function(e) {
			e.target.parentElement.parentElement.classList.add('search-form--focus');
		});
		searchField.addEventListener('blur', function(e) {
			e.target.parentElement.parentElement.classList.remove('search-form--focus');
		});

		// Image card block
		var $cardImages = $('.ct-block-image-card');
		$cardImages.each(function(i, card) {
			$(card).mouseenter(function() {
				if ($(window).width() >= 1200) {
					$(this).addClass('ct-block-image-card--hover');
					$('.ct-block-image-card__description-container', this).slideDown();
				}
			}).mouseleave(function() {
				if ($(window).width() >= 1200) {
					$(this).removeClass('ct-block-image-card--hover');
					$('.ct-block-image-card__description-container', this).slideUp();
				}
			});
		});

		// Site header transparent background 
		var $header = $('.site-header');
		if ($header.hasClass('site-header--transparent')) {
			// On page load
			if ($(window).scrollTop() >= 100) {
				$header.removeClass('site-header--transparent');
			} else if ($(window).scrollTop() < 100) {
				$header.addClass('site-header--transparent');
			}
			// On scroll
			$(window).scroll(function() {
				if ($(window).scrollTop() >= 100) {
					$header.removeClass('site-header--transparent');
				} else if ($(window).scrollTop() < 100) {
					$header.addClass('site-header--transparent');
				}
			})
		}

		// Add scroll to mega menu if too high
		/*
		var $vh = $(window).height();
		var $headerHeight = $($header).height();
		var $subMenus = $('#primary-menu > .menu-item > .sub-menu');
		$subMenus.each(function(i, menu) {
			if (($(menu).height() + $headerHeight) > ($vh - 40)) {
				menu.style.maxHeight = ($vh - $headerHeight - 40) + 'px';
				menu.style.overflowY = 'scroll';
			}
		})
		*/

		// Menu drop-down open/close transition
		/*
		$('#primary-menu > .menu-item.menu-item-has-children').hover(mouseEnter, mouseLeave);
		function mouseEnter() {
			$('> .sub-menu', this).css('display', 'flex').hide().fadeIn();
		};
		function mouseLeave() {
			$('> .sub-menu', this).fadeOut();
		};
		*/

		// Mobile search
		var $mobileHeaderSearchToggle = $('#mobile-header-search-toggle');
		var $headerSearchMobile = $('#header-search-mobile');
		$mobileHeaderSearchToggle.click(function() {
			if ($(this).attr('aria-expanded') === 'false') {
				$(this).attr('aria-expanded', 'true');
				$headerSearchMobile.fadeIn();	
			} else {
				$(this).attr('aria-expanded', 'false');
				$headerSearchMobile.fadeOut();	
			}
		});

		// Mobile navigation
		var $mobileNavToggle = $('#primary-menu-mobile-toggle');
		var $mobileNav = $('#site-navigation-mobile');
		$mobileNavToggle.click(function() {
			if ($(this).attr('aria-expanded') === 'false') {
				$(this).attr('aria-expanded', 'true');
				$(this).addClass('expanded');
				$mobileNav.slideDown();	
			} else {
				$(this).attr('aria-expanded', 'false');
				$(this).removeClass('expanded');
				$mobileNav.slideUp();	
			}
		});
		var $mobileMenuItemsWithChildren = $('.menu-item-has-children', $mobileNav);
		$mobileMenuItemsWithChildren.each(function(i, item) {
			$(item).click(function(e) {
				// Don't trigger links withoug href attributes or with '#' as href value
				if (e.target.nodeName === 'A' && (! e.target.attributes.href || e.target.attributes.href.value === '#')) {
					e.preventDefault();
				}
				e.stopPropagation();
				$subMenu = $('> .sub-menu', item);
				if (!$(item).hasClass('expanded')) {
					$subMenu.slideDown();
					$(item).addClass('expanded');
				} else {
					$subMenu.slideUp();
					$(item).removeClass('expanded');
				}
			});
		});
	});
})(jQuery);
